import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {CouponLandingPageHeaderLoadingMobile} from './CouponLandingPageHeaderLoading.mobile';
import {
  CouponLandingPageHeaderViewMobile,
  CouponLandingPageHeaderViewMobileProps,
} from './CouponLandingPageHeaderView.mobile';
import {useCouponLandingPageHeader} from './useCouponLandingPageHeader';

export const CouponLandingPageHeaderMobile: React.FC<
  CouponLandingPageHeaderViewMobileProps
> = props => {
  return (
    <DataFetcher
      request={useCouponLandingPageHeader()}
      View={CouponLandingPageHeaderViewMobile}
      viewProps={props}
      Error={null}
      Loading={CouponLandingPageHeaderLoadingMobile}
    />
  );
};
